var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NsSlottedDropdown",
    {
      key: _vm.dropdownList.length,
      class: [
        _vm.$style.slottedDropdown,
        { NsSlottedDropdown__small: _vm.size === "small" },
      ],
      attrs: {
        label: _vm.label || _vm.translations.quantity,
        selected: String(_vm.selectedValue),
        disabled: _vm.disabled,
        "show-custom-selected-item": _vm.showCustomSelectedItem,
        "error-message": _vm.errorMessage,
        width: _vm.widthProp,
        "inline-label": _vm.inlineLabel,
        translations: _vm.translations,
        "show-all": "",
        tall: "",
        "dense-list": "",
        "data-testid": "quantitySelector",
      },
      on: { select: _vm.handleSelect },
      scopedSlots: _vm._u([
        {
          key: "custom",
          fn: function () {
            var _obj
            return [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.quantityInput,
                    expression: "quantityInput",
                    modifiers: { number: true },
                  },
                ],
                ref: "input",
                class: [
                  _vm.$style.customInput,
                  ((_obj = {}),
                  (_obj[_vm.$style.small] = _vm.size === "small"),
                  _obj),
                ],
                attrs: { type: "number", min: "0", step: "1" },
                domProps: { value: _vm.quantityInput },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.quantityInput = _vm._n($event.target.value)
                    },
                    _vm.handleInput,
                  ],
                  blur: [
                    _vm.handleBlur,
                    function ($event) {
                      return _vm.$forceUpdate()
                    },
                  ],
                  keypress: _vm.handleKeypress,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    _vm._l(_vm.dropdownList, function (num) {
      return _c(
        "div",
        {
          key: num,
          attrs: { "data-value": _vm.useInput(num) ? "custom" : num },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.useInput(num) ? _vm.dropdownMax + "+" : num) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }